import { ResponsesInteractionChannelAuditResponse } from '@genial/services/dist/models';

export const normalizeInteractionChannels = (
  data?: ResponsesInteractionChannelAuditResponse[] | null
) => {
  if (!data) {
    return [];
  }

  return data.map((item) => ({
    label: item.interactionChannelAudit.description,
    value: item.interactionChannelAudit.interactionChannelAuditId?.toString(),
    options: (item.interactionChannelAudit.interactionChannelOptions || [])?.map((option) => ({
      label: option.channel || '',
      value: option.value || '',
    })),
  }));
};
